import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createabout, updateabout, getabout, deleteabouts } from '../../ReduxToolkit/Slice/About/About';
import JoditEditor from 'jodit-react';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';



function About() {
  const closeButtonRef = useRef(null); // Ref to the close button
  const dispatch = useDispatch();
  const { status, abouts } = useSelector((state) => state.about || { status: 'idle', about: { data: [] } });

  const [AboutImage, setAboutImage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isDescriptionValid, setIsDescriptionValid] = useState(true); // For description validation

  // create
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!description) {
      setIsDescriptionValid(false);
      return;
    }
    setIsDescriptionValid(true);
    const formData = new FormData();
    formData.append('AboutImage', AboutImage === null ? "" : AboutImage);
    formData.append('title', title);
    formData.append('description', description);
    dispatch(createabout(formData));
    setAboutImage(null);
    setTitle("");
    setDescription("");
    closeButtonRef.current.click();
  };
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getabout())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (aboutid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this About Content?")
    if (Isconfirmed) {
      dispatch(deleteabouts(aboutid))
    };
  }
  // single data fetch
  const [updateButton, setupdateButton] = useState("d-none")
  const [SubmitButton, setSubmitButton] = useState("")
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selecteabout = abouts.data.find(about => about._id === id);
    setTitle(selecteabout.title);
    setAboutImage(selecteabout.AboutImage);
    setDescription(selecteabout.description);
    setSelectedId(id);
    if (selecteabout) {
      setupdateButton("")
      setSubmitButton("d-none")
    }
    else { }
  };
  // update
  const handleEdit = () => {
    const formData = new FormData();
    formData.append('AboutImage', AboutImage === null ? "" : AboutImage);
    formData.append('title', title);
    formData.append('description', description);
    dispatch(updateabout({ selectedId, formData }));
    setAboutImage(null);
    setTitle("");
    setDescription("");
  }
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const columns = [
    { label: "Title", accessor: "title" },
    { label: "Description", accessor: "description" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },

  ];
  return (
    <>
      <div>
        <ToastContainer />
        <div className='d-flex justify-content-between my-3'>
          <h3>About Us</h3>
          <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  About Us</button>
        </div>
        <CommanTable
          columns={columns}
          data={abouts.data || []}
          status={status}
          onDelete={handleDelete}
          onEdit={handlid}
          databstarget="#exampleModal"
          model="modal"
        />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload about
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3 col-lg-6">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      required
                      name="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Title"
                    />
                  </div>
                  <div className="mb-3 col-lg-6">
                    {/* <img src={thumbnail} className='img-fluid rounded' alt="" /> */}
                    <label htmlFor="AboutImage" className="form-label">
                      Image
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      required
                      id="thumbnail"
                      name="thumbnail"
                      // value={thumbnail}
                      onChange={(e) => setAboutImage(e.target.files[0])}
                    />
                  </div>
                  <div className="mb-3 col-lg-12">
                    <label htmlFor="content" className="form-label">
                      description
                    </label>
                    <JoditEditor
                      required={true} //
                      value={description}
                      tabIndex={1} // 
                      onBlur={newdescription => setDescription(newdescription)}
                      onChange={newdescription => { }}
                    />
                  </div>
                  <div className={`modal-footer ${SubmitButton}`}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      ref={closeButtonRef}
                    >
                      Close
                    </button>
                    <button type="submit" className={`btn btn-primary`}>
                      Upload
                    </button>
                  </div>
                </div>
              </form>


              <div className={`modal-footer ${updateButton}`}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal"  >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
